import { RxHamburgerMenu } from "react-icons/rx";
import SelectLang from "../../selectLang/selectLang";
import { Navigation } from "../navigation/navigation";
import './header.scss'
import { useState } from "react";
import { Link } from "react-router-dom";
import type { HeaderStyleParams } from "../../../interfaces/headerStyleParams";

export default function Header(headerProps:{
    styleParams:HeaderStyleParams,translations?:any}){
    const [isMenuActive, setIsMenuActive] = useState(false);
    const displayMenu = ()=>{
        setIsMenuActive(!isMenuActive);
    }

    return (<>
        <header id="header-menu" className={headerProps.styleParams.sticky?"fix":""} >
            <div className="mobile-only">
                <RxHamburgerMenu  size={24} onClick={displayMenu}/>
            </div>
            <SelectLang />
            <div className="sub-header">
                <div className='logo-container'>
                    <Link to="/">
                        <img className='logo' src="/assets/img/logo.svg" alt='jnicolas.art' title='www.jnicolas.art'/>
                    </Link>
                </div>
                <Navigation isMobileActive={isMenuActive} />
            </div>
        </header>
    </>)
}